import { notify } from 'utils/reduxUtils';

export const types = {
  TWO_FACTOR_AUTH_SECRET_REQUEST:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_SECRET_REQUEST',
  TWO_FACTOR_AUTH_SECRET_SUCCESS:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_SECRET_SUCCESS',
  TWO_FACTOR_AUTH_SECRET_ERROR:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_SECRET_ERROR',
  TWO_FACTOR_AUTH_VERIFY_TOKEN_REQUEST:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_VERIFY_TOKEN_REQUEST',
  TWO_FACTOR_AUTH_VERIFY_TOKEN_SUCCESS:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_VERIFY_TOKEN_SUCCESS',
  TWO_FACTOR_AUTH_VERIFY_TOKEN_ERROR:
    'auth/twoFactorAuth/TWO_FACTOR_AUTH_VERIFY_TOKEN_ERROR',
};

export const twoFactorAuthSecret = {
  request: ({ id }) => ({
    type: types.TWO_FACTOR_AUTH_SECRET_REQUEST,
    payload: { id },
  }),
  success: ({ secret, uri }) => ({
    type: types.TWO_FACTOR_AUTH_SECRET_SUCCESS,
    payload: { secret, uri },
  }),
  error: notify(
    (error) => ({
      type: types.TWO_FACTOR_AUTH_SECRET_ERROR,
      payload: error,
    }),
    'Failed to enable two factor authentication',
  ),
};

export const verifyToken = {
  request: ({ id, token, secret }) => ({
    type: types.TWO_FACTOR_AUTH_VERIFY_TOKEN_REQUEST,
    payload: { id, token, secret },
  }),
  success: notify(
    () => ({
      type: types.TWO_FACTOR_AUTH_VERIFY_TOKEN_SUCCESS,
    }),
    'Two Factor Authentication Enabled.',
  ),
  error: notify(
    (error) => ({
      type: types.TWO_FACTOR_AUTH_VERIFY_TOKEN_ERROR,
      payload: error,
    }),
    'Error verifying token. Please try again',
  ),
};
